class EmailController {
  constructor() {
    this.name = 'email';
  }
}

export default EmailController;



// WEBPACK FOOTER //
// ./client/app/components/email/email.controller.js